'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UISelectableButton = require('UIComponents/button/UISelectableButton');

var _UISelectableButton2 = _interopRequireDefault(_UISelectableButton);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var buttonTypeProps = (0, _keyMirror2.default)({
  button: null,
  selectableButton: null,
  selectableButtonTest: null
});

var CommunicationButton = function (_React$Component) {
  _inherits(CommunicationButton, _React$Component);

  function CommunicationButton(props) {
    _classCallCheck(this, CommunicationButton);

    var _this = _possibleConstructorReturn(this, (CommunicationButton.__proto__ || Object.getPrototypeOf(CommunicationButton)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(CommunicationButton, [{
    key: 'getI18nString',
    value: function getI18nString() {
      var communicationKey = this.props.communicationKey;

      var i18nKey = communicationKey.toLowerCase();

      return _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.' + i18nKey });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          upgradeData = _props.upgradeData,
          onClick = _props.onClick,
          setSelectedCommunicationMethod = _props.setSelectedCommunicationMethod,
          communicationKey = _props.communicationKey;


      onClick(upgradeData);
      setSelectedCommunicationMethod(communicationKey);
    }
  }, {
    key: 'renderSelectableButtonTest',
    value: function renderSelectableButtonTest() {
      var communicationKey = this.props.communicationKey;

      var className = (0, _classNames2.default)(communicationKey, 'p-x-8', 'p-y-4');
      return _react2.default.createElement(_UISelectableButton2.default, {
        block: true,
        className: className,
        onClick: this.handleClick,
        textLabel: this.getI18nString()
      });
    }
  }, {
    key: 'renderSelectableButton',
    value: function renderSelectableButton() {
      var _props2 = this.props,
          image = _props2.image,
          communicationKey = _props2.communicationKey,
          useIllustration = _props2.useIllustration;


      return _react2.default.createElement(
        _UISelectableButton2.default,
        {
          className: communicationKey,
          size: 'large',
          onClick: this.handleClick,
          textLabel: this.getI18nString()
        },
        useIllustration ? _react2.default.createElement(_UIIllustration2.default, { name: image, height: 75 }) : _react2.default.createElement(_UIImage2.default, { src: image, responsive: false, height: 75 })
      );
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var communicationKey = this.props.communicationKey;


      return _react2.default.createElement(
        _UIButton2.default,
        {
          use: 'primary-white',
          className: communicationKey,
          block: true,
          onClick: this.handleClick
        },
        this.getI18nString()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var buttonType = this.props.buttonType;

      var ButtonComponent = {
        button: this.renderButton(),
        selectableButton: this.renderSelectableButton(),
        selectableButtonTest: this.renderSelectableButtonTest()
      };

      return ButtonComponent[buttonType];
    }
  }]);

  return CommunicationButton;
}(_react2.default.Component);

CommunicationButton.defaultProps = {
  buttonType: buttonTypeProps.button,
  useIllustration: true
};

CommunicationButton.propTypes = {
  onClick: _react.PropTypes.func.isRequired,
  image: _react.PropTypes.string.isRequired,
  setSelectedCommunicationMethod: _react.PropTypes.func.isRequired,
  communicationKey: _react.PropTypes.string.isRequired,
  buttonType: _react.PropTypes.oneOf(Object.keys(buttonTypeProps)),
  upgradeData: _react.PropTypes.object.isRequired,
  useIllustration: _react.PropTypes.bool
};

exports.default = CommunicationButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/CommunicationButton.js
// module id = 570
// module chunks = 3 4 5